const prefix = '/onlinecs/knowledgedata'

/**
 * 查询问答数据总览权限
 * @type {string}
 */
export const queryKnowledgeDataRole = `${prefix}/queryKnowledgeDataRole`

/**
 * 查询小程序/官网辅助问答总数据看板
 * @type {string}
 */
export const queryAssistAnswerTotalData = `${prefix}/queryAssistAnswerTotalData`

/**
 * 查询小程序/官网辅助问答数据列表
 * @type {string}
 */
export const queryAssistAnswerListData = `${prefix}/queryAssistAnswerListData`

/**
 * 查询小程序/官网自动问答总数据看板
 * @type {string}
 */
export const queryAutomaticAnswerTotalData = `${prefix}/queryAutomaticAnswerTotalData`

/**
 * 查询小程序/官网自动问答数据列表
 * @type {string}
 */
export const queryAutomaticAnswerListData = `${prefix}/queryAutomaticAnswerListData`

/**
 * 查询京东辅助问答总数据看板
 * @type {string}
 */
export const queryJdAssistAnswerTotalData = `${prefix}/queryJdAssistAnswerTotalData`

/**
 * 查询京东辅助问答数据列表
 * @type {string}
 */
export const queryJdAssistAnswerListData = `${prefix}/queryJdAssistAnswerListData`

/**
 * 下载小程序/官网辅助问答数据
 * @type {string}
 */
export const downloadAssistAnswerData = `${prefix}/downloadAssistAnswerData`

/**
 * 下载小程序/官网自动问答数据
 * @type {string}
 */
export const downloadAutomaticAnswerData = `${prefix}/downloadAutomaticAnswerData`

/**
 * 下载京东辅助问答数据
 * @type {string}
 */
export const downloadJdAssistAnswerData = `${prefix}/downloadJdAssistAnswerData`

/**
 * 查询所有有问答数据的店铺
 * @type {string}
 */
export const queryShopRoleByAnswer = `${prefix}/queryShopRoleByAnswer`

/**
 * 下载问答数据总览
 * @type {string}
 */
export const downloadKnowledgeDataByAllShop = `${prefix}/downloadKnowledgeDataByAllShop`

/**
 * 查询全自动接待总数据看板
 * @type {string}
 */
export const queryAutoRobotTotalData = `${prefix}/queryAutoRobotTotalData`

/**
 * 查询全自动接待数据列表
 * @type {string}
 */
export const queryAutoRobotListData = `${prefix}/queryAutoRobotListData`

/**
 * 下载全自动接待数据
 * @type {string}
 */
export const downloadAutoRobotData = `${prefix}/downloadAutoRobotData`
